import { Link } from 'react-router-dom'
import { Sparkles, MessageSquareQuote, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib/auth-context'

export default function Landing() {
  const { me } = useAuth()

  return (
    <div className="min-h-full">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-6 py-5">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M22 5.8a8.5 8.5 0 0 1-2.4.7 4.2 4.2 0 0 0 1.8-2.3c-.8.5-1.7.8-2.7 1a4.2 4.2 0 0 0-7.1 3.8A11.9 11.9 0 0 1 3 4.9a4.2 4.2 0 0 0 1.3 5.6c-.7 0-1.3-.2-1.9-.5v.1a4.2 4.2 0 0 0 3.3 4.1 4.3 4.3 0 0 1-1.9.1A4.2 4.2 0 0 0 7.8 17 8.4 8.4 0 0 1 2 19a12 12 0 0 0 6.4 1.9c7.6 0 11.8-6.3 11.8-11.8v-.5A8.4 8.4 0 0 0 22 5.8"/></svg>
          </div>
          <span className="font-semibold">Bluebird</span>
        </div>
        <div>
          {me ? (
            <Button asChild size="sm"><Link to="/app">Open app<ArrowRight className="h-4 w-4" /></Link></Button>
          ) : (
            <Button asChild variant="ghost" size="sm"><Link to="/login">Sign in</Link></Button>
          )}
        </div>
      </header>

      <section className="mx-auto max-w-3xl px-6 pt-16 pb-8 text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full border bg-accent px-3 py-1 text-xs font-medium text-accent-foreground">
          <Sparkles className="h-3 w-3" />
          Grow on X without risking your account
        </div>
        <h1 className="text-balance text-5xl font-semibold tracking-tight">
          Turn your shipping into a following.
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-pretty text-lg text-muted-foreground">
          Bluebird helps indie founders grow on X the honest way: great replies to the right
          tweets in your vertical and polished threads from your changelogs — no risky
          follow-churn, no account bans.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Button asChild size="lg"><Link to={me ? '/app' : '/login'}>Get started</Link></Button>
          <Button asChild variant="ghost" size="lg">
            <a href="#features">See features</a>
          </Button>
        </div>
      </section>

      <section id="features" className="mx-auto grid max-w-4xl gap-4 px-6 py-12 md:grid-cols-2">
        <Feature
          icon={<MessageSquareQuote className="h-5 w-5" />}
          title="Engagement assistant"
          body="Click the bookmarklet on any tweet — or paste a URL — and Claude drafts three replies in your voice. You pick, edit, send."
        />
        <Feature
          icon={<Sparkles className="h-5 w-5" />}
          title="Thread generator + scheduler"
          body="Feed it a changelog or a rough note. Out comes a polished, non-cringe thread, ready to post or schedule."
        />
      </section>

      <footer className="border-t py-8 text-center text-sm text-muted-foreground">
        Bluebird · Built on Cloudflare · Free tier for founders
      </footer>
    </div>
  )
}

function Feature(props: { icon: React.ReactNode; title: string; body: string }) {
  return (
    <div className="rounded-lg border bg-card p-5">
      <div className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-md bg-accent text-accent-foreground">
        {props.icon}
      </div>
      <div className="mb-1 font-medium">{props.title}</div>
      <p className="text-sm text-muted-foreground">{props.body}</p>
    </div>
  )
}
